import ContentBlock from "@/components/newsletter/blocks/ContentBlock";
import Album from "@/components/album";
import AlbumLogin from "@/components/album-login";
import dynamicLocalization from "@/mixins/dynamic-localization";
import standardRequest from "@/mixins/request/standard";
import guestRequest from "@/mixins/request/guest";

export default {
  mixins: [dynamicLocalization, standardRequest, guestRequest],
  components: { ContentBlock, Album, AlbumLogin },
  data() {
    return {
      error: null,
      ticketId: null,
      albumId: null,
      album: null,
      photos: [],
    };
  },
  mounted() {
    this.albumId = this.$route.params.albumId;
    this.loadAlbum();
  },
  methods: {
    checkTicketId(ticketId) {
      this.ticketId = ticketId;
      this.fetchPictures();
    },
    loadAlbum() {
      this.standardRequest(
        "GET",
        `gallery/${this.albumId}/info`,
        (res) => {
          this.album = res.data;
        },
        (err) => {
          this.error = err;
        }
      );
    },
    fetchPictures() {
      if (!this.ticketId) {
        this.pictures = [];
        return;
      }

      const guestCredentials = {
        eventId: this.$route.params.albumId,
        ticketId: this.ticketId,
      };

      this.guestRequest(
        "GET",
        `gallery/${this.albumId}/photos`,
        guestCredentials,
        (res) => {
          this.album = res.data;
        },
        (err) => {
          this.error = err;
          this.ticketId = null;
        }
      );
    },
  },
};
